import React from 'react';
import { ImageBlock } from '../../components/Blocks/ImageBlock';
import bg from '../../assets/newbg.jpg'

import logo from '../../assets/system3-logo.svg'
import './about.scss'
import { cssUrl } from '../../tools/Utils';

export class About extends React.Component
{
	state = {tel:'', mail:'',telText:"Teléfono",mailText:"EMail"}
	componentDidMount()
	{
		this.setState({tel:'tel:+34986493288',telText:"986 493 288", mail:"mailto:info@system3.es",mailText:"info@system3.es"});
	}
	render()
	{
		return (
			<ImageBlock src={bg} id="about">
				<img src={cssUrl(logo)} />
				<h1>Contactanos</h1>
				<div>
					<a href={this.state.tel} >{this.state.telText}</a><span> · </span>
					<a href={this.state.mail} >{this.state.mailText}</a> <span> · </span>
					<a target="_blank" rel="noopener noreferrer" href="https://goo.gl/maps/pQtn2q6YG2R2">Localización</a>
				</div>
			</ImageBlock>
		);
	}
}